import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.sass'],
})
export class ConfirmationModalComponent {
  message = 'Are you sure?';
  submessage = '';
  bodyMessage = '';
  confirmButtonText = 'Yes';
  cancelButtonText = 'Cancel';
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationModalComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.submessage = data.submessage || this.submessage;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
      if (data.bodyMessage) {
        this.bodyMessage = data.bodyMessage;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
